import React from 'react'
import { Link } from 'react-router-dom'
import { GxIcon } from '@garpix/garpix-web-components-react'
import AuthorizationApp from '@/apps/Authorization'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Button from '@/components/Button'
import CabinetNavigation from './CabinetNavigation'
import Container from '@/components/Container'
import Title from '@/components/Title'
import { useCurrentUser, usePage } from '@/hooks'
import { logoutIcon, urbanLogo } from '@/images'
import { AvatarEditor } from '@/apps/Profile/components'
import style from '../styles/cabinet.module.scss'

const CabinetLayout = ({ children }): React.ReactElement => {
  const { currentUser, logout } = useCurrentUser()
  const page = usePage()
  const { object } = page?.init_state
  const { config } = page?.init_state?.global
  const cabinetMenu = page?.init_state?.global?.menus?.cabinet

  return (
    <>
      <Title hidden type='h1'>
        {object.title}
      </Title>

      <Container className={style.cabinet}>
        {currentUser === null
          ? (
            <div className={style.cabinet__spinner}>
              <BlockSpinner />
            </div>
            )
          : null}

        {currentUser?.status === true
          ? (
            <>
              <div className={style.cabinet_left}>
                <AvatarEditor />
                <div className={style.cabinet__name_block}>
                  <span className={style.cabinet__name_title}>Пользователь</span>
                  <p className={style.cabinet__name_wrap}>
                    {/* {currentUser.last_name !== null && currentUser.last_name !== ''
                      ? (
                        <span className={style.cabinet__name}>
                          {currentUser?.last_name}
                        </span>
                        )
                      : (
                          undefined
                        )} */}
                    {currentUser.name !== null && currentUser.name !== ''
                      ? (
                        <span className={style.cabinet__name}>
                          {currentUser?.name}
                        </span>
                        )
                      : (
                          undefined
                        )}
                    {currentUser.last_name === '' && currentUser.name === ''
                      ? (
                        <span className={style.cabinet__name}>
                          {currentUser.login}
                        </span>
                        )
                      : null}
                  </p>
                </div>
                <Link
                  to={config.urban_club}
                  className={style.cabinet_urban__link}
                >
                  <GxIcon src={urbanLogo} className={style.cabinet_urban__logo} />
                  Клуб урбанистов
                </Link>
                <Button
                  onClick={logout}
                  wide
                  highlight
                  size='extralarge'
                  className={style.cabinet__logout}
                >
                  <GxIcon src={logoutIcon} slot='icon-left' />
                  Выйти
                </Button>
              </div>

              <div className={style.cabinet_right}>
                <CabinetNavigation pageId={object.id} cabinetMenu={cabinetMenu} />

                {children}
              </div>
            </>
            )
          : null}
        {currentUser?.status === false
          ? (
            <div className={style.cabinet__auth}>
              <AuthorizationApp />
            </div>
            )
          : null}
      </Container>
    </>
  )
}

export default CabinetLayout
